// SessionManager.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { refreshToken as refreshAccessTokenShared } from './auth';

async function refreshAccessToken() {
  const newToken = await refreshAccessTokenShared();
  if (!newToken) {
    throw new Error('Token refresh returned an empty token');
  }
  return newToken;
}

export default function SessionManager({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const { exp } = jwtDecode(token);
	  
      const expiresAt = new Date(exp * 1000);
      const msUntilExpiry = exp * 1000 - Date.now();

      console.log("Token expires at:", expiresAt.toLocaleString());
      console.log("Milliseconds until expiry:", msUntilExpiry);

      // If token is already expired, try to refresh it
      if (Date.now() >= exp * 1000) {
        console.log("Token already expired. Attempting to refresh...");
        refreshAccessToken()
          .then((newToken) => {
            console.log("Token refreshed successfully");
            // Token refreshed, no need to log out
          })
          .catch((error) => {
            console.log("Token refresh failed:", error);
            localStorage.clear();
            alert("Session expired. Please log in again.");
            onLogout?.();
            navigate("/");
          });
        return;
      }

      // Set up timer to refresh token before it expires (refresh 1 minute before expiry)
      const refreshTime = exp * 1000 - Date.now() - 60000; // 1 minute before expiry
      const timer = setTimeout(async () => {
        try {
          console.log("Refreshing token before expiry...");
          await refreshAccessToken();
          console.log("Token refreshed successfully");
        } catch (error) {
          console.log("Token refresh failed:", error);
          localStorage.clear();
          alert("Session expired. Please log in again.");
          onLogout?.();
          navigate("/");
        }
      }, refreshTime);

      return () => clearTimeout(timer);
    } catch {
      localStorage.clear();
      onLogout?.();
      navigate("/");
    }
  }, [location, navigate, onLogout]);

  return null; // This component doesn't render anything
}
